module.exports = __webpack_public_path__ + "img/keyboard-up-arrow.f0b18641.svg";